import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const planDependenciesReportEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-plan-dependencies-report-entrypoint" */ './index'),
	),
	getPreloadProps: () => ({}),
});
